/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core'
import { FacetListModule, IconModule } from '@spartacus/storefront'
import { CustomActiveFacetsModule } from './custom-active-facets/custom-active-facets.module'
import { CustomProductFacetNavigationComponent } from './custom-product-facet-navigation.component'

@NgModule({
  imports: [
    CommonModule,
    FacetListModule,
    CustomActiveFacetsModule,
    IconModule,
    I18nModule,
    ConfigModule.withConfig(<CmsConfig>{
      cmsComponents: {
        ProductRefinementComponent: {
          component: CustomProductFacetNavigationComponent
        }
      }
    })
  ],
  declarations: [CustomProductFacetNavigationComponent],
  exports: [CustomProductFacetNavigationComponent]
})
export class CustomProductFacetNavigationModule {}
